import { Component } from 'react';

/**
 * La red que evita la pantalla en blanco.
 *
 * QUE PROBLEMA RESUELVE, medido en produccion. Entrar al sitio JUSTO mientras
 * se despliega deja la pagina vacia: el `index.html` nuevo ya se sirve y
 * apunta a trozos de JavaScript con huella nueva, pero esos trozos aun se
 * estan subiendo. La importacion dinamica falla, el error sube sin que nadie
 * lo recoja y React desmonta el arbol entero -- `#root` sin un solo hijo. Sin
 * consola abierta no hay forma de saber que ha pasado ni que se arregla
 * recargando.
 *
 * El detector de version nueva de App cubre OTRO caso: la pestaña que lleva
 * dias abierta con codigo viejo. No cubre a quien carga la pagina durante el
 * despliegue, que es una ventana de segundos -- y por eso no se nota nunca
 * hasta que le toca a alguien.
 *
 * POR QUE UNA CLASE. Es el unico componente de clase del proyecto y no es un
 * despiste: `componentDidCatch` no tiene equivalente en hooks. React no ofrece
 * otra forma de interceptar un error de render.
 *
 * DOS MENSAJES, no uno. Un fallo al traer un trozo de codigo y un fallo de
 * programacion nuestro se arreglan igual (recargar) pero NO son lo mismo, y
 * decir "hubo un error" cuando lo que pasa es que acabas de pillar un
 * despliegue a medias hace que la gente piense que el sitio esta roto.
 *
 * El texto va EN ESTE FICHERO y no en i18n. Este componente tiene que poder
 * pintar cuando lo de debajo se ha caido, y eso incluye la posibilidad de que
 * lo caido sea el proveedor de idioma: un `useLang()` aqui seria justo la
 * dependencia que no se puede tener.
 */

/**
 * Un fallo al traer un trozo de codigo, y no un error nuestro.
 *
 * Los mensajes los pone el navegador y cambian entre motores, asi que se
 * reconocen por varias formas a la vez. Los dos primeros son de Vite; el
 * `Failed to fetch` suelto aparece cuando el trozo ni se llego a pedir.
 */
const esTrozoQueFalta = (err) => {
  const m = String(err?.message ?? err ?? '');
  return (
    /dynamically imported module/i.test(m) ||
    /Importing a module script failed/i.test(m) ||
    /ChunkLoadError/i.test(String(err?.name ?? '')) ||
    /Failed to fetch/i.test(m)
  );
};

const TEXTOS = {
  es: {
    versionTitulo: 'Se acaba de publicar una versión nueva',
    versionCuerpo:
      'Entraste justo mientras se actualizaba el sitio, así que faltó una pieza. No es nada tuyo: recarga y ya está.',
    erroTitulo: 'Algo se rompió por nuestra parte',
    erroCuerpo: 'No es nada que hayas hecho. Recargar suele bastar; si vuelve a pasar, cuéntanoslo.',
    recargar: 'Recargar',
  },
  en: {
    versionTitulo: 'A new version was just published',
    versionCuerpo:
      'You arrived while the site was updating, so a piece was missing. Nothing on your end: reload and you are set.',
    erroTitulo: 'Something broke on our side',
    erroCuerpo: 'Nothing you did. Reloading usually fixes it; if it happens again, tell us.',
    recargar: 'Reload',
  },
};

export default class Salvavidas extends Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }

  static getDerivedStateFromError(err) {
    return { err };
  }

  componentDidCatch(err) {
    /*
     * Se deja constancia en la consola a proposito: la pantalla ya explica lo
     * que hay que hacer, pero sin traza no hay forma de investigar un error de
     * verdad cuando alguien lo reporta.
     */
    console.error('[salvavidas]', err);
  }

  render() {
    const { err } = this.state;
    if (!err) return this.props.children;

    /* El idioma se lee del documento y no de un contexto de React: si lo que
       falló fue el proveedor de idioma, un contexto aquí no existiría. */
    const lang = document.documentElement.lang === 'en' ? 'en' : 'es';
    const t = TEXTOS[lang] ?? TEXTOS.es;
    const deVersion = esTrozoQueFalta(err);

    return (
      <div className="salvavidas" role="alert">
        <p className="salvavidas__titulo">{deVersion ? t.versionTitulo : t.erroTitulo}</p>
        <p className="salvavidas__cuerpo">{deVersion ? t.versionCuerpo : t.erroCuerpo}</p>
        <button type="button" className="btn" onClick={() => window.location.reload()}>
          {t.recargar}
        </button>
      </div>
    );
  }
}
